













































































































import { Component, Prop } from "vue-property-decorator"
import Super from "@/pv4-super-class"
import { map, range } from "lodash"

@Component({})
export default class Pagination extends Super {
  @Prop({ required: true }) data: any
  @Prop({ required: true }) identifier: any
  @Prop({ required: false, default: 6 }) itemsPerPage
  @Prop({ required: true, default: "custom" }) format: any
  @Prop({ required: false, default: 1}) currentPage!: number
  minPage = 1

  mounted() {
    this.update()
  }

  /**
   * Gets the highest item that should be shown to the user
   */
  get high() {
    return this.itemsPerPage * this.currentPage
  }

  /**
   * Gets the lowest item that should be show to the user
   */
  get low() {
    return this.itemsPerPage * this.currentPage - this.itemsPerPage
  }

  /**
   * Gets the highest page necessery to display all the data
   */
  get maxPage() {
    return Math.ceil(this.data.length / this.itemsPerPage)
  }

  /**
   * Gets an array of total pages starting at 1
   */
  get pages() {
    return range(1,this.maxPage + 1)
  }

  /**
   * Gest @param pages minus the first and last element
   */
  get trimmedPages() {
    let trimmed = this.pages
    trimmed.pop()
    trimmed.shift()
    return trimmed
  }

  /**
   * Gets an array of items that should be shown to the user based of the @param identifier
   */
  get returnData() {
    let array = map(this.data, `${this.identifier}`)
    return array.slice(this.low, this.high)
  }

  /**
   * Returns what pages should be shown to the user for the page selection
   */
  get middlePages() {
    let lowerPage
    let middlePage
    let upperPage

    let upperVariable = this.maxPage - 2
    let lowerVariable = 1 + 2

    if (this.currentPage <= lowerVariable) {
      lowerPage = this.minPage + 1
      middlePage = this.minPage + 2
      upperPage = this.minPage + 3
    } else if (this.currentPage >= upperVariable) {
      lowerPage = this.maxPage - 3
      middlePage = this.maxPage - 2
      upperPage = this.maxPage - 1
    } else {
      lowerPage = this.currentPage - 1
      middlePage = this.currentPage
      upperPage = this.currentPage + 1
    }
    return [lowerPage, middlePage, upperPage]
  }

  /**
   * Returns the array of which items should be shown to the user based with the @param identifier
   */
  update() {
    if (this.format == "table") {
      this.$emit("update", [this.currentPage, this.itemsPerPage])
    }
    if (this.format == "custom") {
      this.$emit("update", [this.returnData, this.currentPage])
    }
  }
}
